import React, { FC } from 'react';
import cn from 'classnames';

import LazyImage from 'crehana-ui/LazyImage';

interface RatioProps {
  poster?: string;
  posterPlaceholder?: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Ratio: FC<RatioProps> = ({
  poster,
  posterPlaceholder,
  title,
  className,
  style,
}) => (
  <div
    className={cn('cp-ratio w-full relative', className)}
    style={{ paddingTop: `${(9 / 16) * 100}%`, ...style }}
  >
    {poster && (
      <div className="absolute inset-0 w-full h-full">
        <LazyImage
          className="w-full h-full"
          imgClassName="object-cover"
          alt={title || ''}
          src={poster}
          placeholder={posterPlaceholder}
        />
      </div>
    )}
  </div>
);

export default Ratio;
